import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThreeLinerComponent } from './three-liner.component';

@NgModule({
    declarations: [ThreeLinerComponent],
    imports: [CommonModule],
    exports: [ThreeLinerComponent],
})
export class ThreeLinerModule {}
